"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SameFuelReadingGuideLink = exports.NextFuelReadingGuideLink = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var NextFuelReadingGuideLink = function (_a) {
    var _b;
    var children = _a.children, fuel = _a.fuel;
    var _c = (0, core_1.useComponents)(), PrimaryCTALink = _c.PrimaryCTALink, InternalLink = _c.InternalLink;
    var meterReadsNew = (0, core_1.useLinks)().meterReadsNew;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READINGS_CONFIRMATION_NEXT_FUEL_CTA, properties: (_b = {
                nextFuel: fuel === 'gas' ? 'gas' : 'elec'
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b) },
        react_1.default.createElement(PrimaryCTALink, { as: InternalLink, "data-testid": "next-fuel-button", href: meterReadsNew({ fuelType: fuel }) }, children)));
};
exports.NextFuelReadingGuideLink = NextFuelReadingGuideLink;
var SameFuelReadingGuideLink = function (_a) {
    var _b;
    var children = _a.children, fuel = _a.fuel, supplyIndex = _a.supplyIndex;
    var _c = (0, core_1.useComponents)(), PrimaryCTALink = _c.PrimaryCTALink, InternalLink = _c.InternalLink;
    var meterReadsNew = (0, core_1.useLinks)().meterReadsNew;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READINGS_CONFIRMATION_SAME_FUEL_CTA, properties: (_b = {
                nextFuel: fuel === 'gas' ? 'gas' : 'elec'
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b) },
        react_1.default.createElement(PrimaryCTALink, { as: InternalLink, "data-testid": "same-fuel-button", href: "".concat(meterReadsNew({ fuelType: fuel }), "?supplyIndex=").concat(supplyIndex) }, children)));
};
exports.SameFuelReadingGuideLink = SameFuelReadingGuideLink;
